import React from "react";
import { Row, Col } from "../../bootstrap/index.jsx";
import DateInput from "../../common/DateInput.jsx";
import FormValueOptions from "./FormValueOptions.jsx";
import FileUpload from "../../common/FileUpload.jsx";

import {
  result_upload_qualitative_indicator_file_path,
  result_open_qualitative_indicator_file_path
} from '~/routes';

const QualitativeIndicatorFormFields = ({
  indicator,
  milestonesEnabled,
  formOptions,
  resultFrameworkId,
}) => {
  return (
    <>
      <input type="hidden" name="target_milestone_id" value={indicator.target_milestone_id} />
      <Row className="form-group">
        <label className="col-xs-6">
          {milestonesEnabled ? (
            <>
              {I18n.t("milestone")}
              <select
                name="project_milestone_id"
                className="form-control"
                defaultValue={indicator.project_milestone_id}
              >
                <option value="">{I18n.t("select_from_list")}</option>
                {formOptions.project_milestones.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </>
          ) : (
            <>
              {I18n.t("due_date")}
              <DateInput name="due_date" defaultValue={indicator.due_date} />
            </>
          )}
        </label>
      </Row>
      <hr />
      <FormValueOptions
        indicatorValueOptions={indicator.value_options}
        qualitativeIndicatorValueOptions={formOptions.qualitative_indicator_value_options}
      />
      <Row className="form-group">
        <label className="col-xs-12">
          {I18n.t("baseline_state")}
          <textarea
            name="baseline_state[description]"
            className="form-control"
            defaultValue={(indicator.baseline_state || {}).description}
          />
        </label>
        <Col>
          <FileUpload
            uploadPath={result_upload_qualitative_indicator_file_path}
            uploadParams={{ result_framework_id: resultFrameworkId }}
            downloadPathCallback={(file) =>
              result_open_qualitative_indicator_file_path({
                indicator_id: indicator.id,
                filename: file.filesystem_name,
              })
            }
            defaultFiles={(indicator.baseline_state || {}).files}
          />
        </Col>
      </Row>
      <Row className="form-group">
        <label className="col-xs-12">
          {I18n.t("target_state")}
          <textarea
            name="target_state"
            className="form-control"
            defaultValue={indicator.target_state}
          />
        </label>
      </Row>
    </>
  );
};

export default QualitativeIndicatorFormFields;
